import {
  StyleSheet,
  Text,
  View,
  Image
} from '@react-pdf/renderer';

const styles = StyleSheet.create({

  title: {
    margin: '0 auto',
    paddingTop: 10,
    fontSize: 10,
    fontWeight: 700
  },

  donorAgreementContentWrapper: {
    fontSize: 9,
    padding: 10,
    lineHeight: 1.3
  },

  listHeading: {
    fontWeight: 500
  },

  authWrapper: {
    marginTop: 5,
    marginBottom: 5
  },
  agreeTermsBoxWrapper: {
    width: '70%',
    padding: 10,
    backgroundColor: '#add8e69e',
    margin: 10,
    position: 'absolute',
    bottom: -200,
    left: 5
  },
  checkboxImage: {
    width: 15,
    height: 15,
  },
  checkboxImagWithTextWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  textWrapper: {
    paddingLeft: 5
  },
  digitalSignatureBoxWrapper: {
    width: '100%',
    padding: 10,
    backgroundColor: '#fff',
    marginTop: 10,
  },

});

const PdfAuthorizationForDisclosure = (props) => {
  const {
    // eslint-disable-next-line react/prop-types
    name, signDate, signTime
  } = props;
  return (
    <View>
      <View style={styles.title}>
        <Text>Authorization for Disclosure of Personal Health Information</Text>
      </View>
      <View />
      <View style={styles.donorAgreementContentWrapper}>

        <View style={styles.authWrapper}>
          <Text style={styles.listHeading}>Consent & Authorization:</Text>
          <Text>
            I hereby authorize averhealth to use and / or disclose my complete health record, including information relating to my substance use monitoring results, mental health care, communicable diseases, HIV or AIDS, and treatment of substance use disorder (“PHI”). averhealth is authorized to disclose my PHI to any referral source that has referred me to averhealth or Medicare, Medicaid, health insurance provider, or other payer source (“Payers”). Referral sources may include my (i) general practitioner, clinical social worker, treatment counselor, or any other health care worker who has a treating provider relationship with me; (ii) employer or prospective employer; (iii) probation officer, deputy officer, court administrator, judge, or any other member of law enforcement or a court; (iv) any entity or individual responsible for using my PHI as directed by my referral source; and (v) any other entity or individual that refers me to averhealth for the purpose of substance use monitoring services (“Referral Source”). averhealth may release my PHI to a Referral Source or Payers for (i) medical treatment or consultation; (ii) substance use treatment, (iii) access compliance with a condition of release, probation, or parole; (iv) billing or claims payment; and (v) other purposes as I may direct (“Permitted Use”).
          </Text>
        </View>

        <View style={styles.authWrapper}>
          <Text style={styles.listHeading}>Term:</Text>
          <Text>
            This consent is subject to revocation at any time except to the extent that the program which is to make the disclosure has already taken action in reliance on it. If not previously revoked, this consent will terminate upon the earlier of (i) two (2) years from the date executed or (ii) the disposition of my medical, substance use disorder treatment, court, probation, or other diversion related case.
          </Text>
        </View>

        <View style={styles.authWrapper}>
          <Text style={styles.listHeading}>Patient Notice:</Text>
          <Text>
            The confidentiality of substance use disorder patient records maintained by averhealth are protected by Federal and State law and regulations. Generally, the program may not communicate to a person outside the program that a patient attends the program, or disclose any information identifying a patient as having substance use disorder. Provided, however, averhealth may disclose my PHI if (i) I consent in writing by signing below; (ii) the disclosure is required or allowed by a court order; or (iii) the disclosure is made to medical personnel in a medical emergency or to qualified personnel for research, audit, or program evaluation. Suspected violations may be reported to appropriate authorities in accordance with Federal and/or state regulations. Federal law and regulations do not protect any information about a crime committed by a patient either at the program or against any person who works for the program or about any threat to commit such a crime. Federal laws and regulations do not protect any information about suspected child abuse or neglect from being reported under State law to appropriate State or local authorities (see 42 U.S.C. 290dd-3 and 42 U.S.C. 290ee-3 for Federal laws and 42 CFR part 2 for Federal regulations).
          </Text>
        </View>
        <View style={styles.authWrapper}>
          <Text style={styles.listHeading}>Patient Acknowledgment:</Text>
          <Text>
            I acknowledge that my treatment, payment, enrollment or eligibility for benefits will not be conditioned on whether I sign this authorization. I acknowledge that information used or disclosed pursuant to this authorization may be disclosed by the recipient and may no longer be protected by federal or state law, although the recipient will be provided with a notice regarding restrictions on disclosure. I acknowledge that I may request a list of entities to which my PHI has been disclosed. I acknowledge that the averhealth Notice of Privacy Practices policy is available for review upon request. I have reviewed this authorization in its entirety and understand the content included herein. By signing this authorization, I am confirming that it accurately reflects my wishes.
          </Text>
        </View>

      </View>
      <View style={styles.agreeTermsBoxWrapper}>
        <View style={styles.checkboxImagWithTextWrapper}>
          <View style={styles.imageWrapper}>
            <Image
              style={styles.checkboxImage}
              src="assets/images/checkbox.png"
            />
          </View>
          <View style={styles.textWrapper}>
            <Text style={{ fontSize: 11 }}>
              I agree that I am {name} or their legal guardian.
            </Text>
          </View>
        </View>
        <View style={styles.checkboxImagWithTextWrapper}>
          <View style={styles.imageWrapper}>
            <Image
              style={styles.checkboxImage}
              src="assets/images/checkbox.png"
            />
          </View>
          <View style={styles.textWrapper}>
            <Text style={{ fontSize: 11 }}>
              I agree to the terms of Donor Agreement
            </Text>
          </View>
        </View>
        <View style={styles.digitalSignatureBoxWrapper}>
          <Text style={{ fontFamily: 'signature', fontSize: 20 }}>{name}</Text>
          <Text style={{ fontFamily: 'Opan Sans Italic' }}>Electronically Signed on {signDate} at {signTime}</Text>
        </View>
      </View>
    </View>
  );
};

export default PdfAuthorizationForDisclosure;
